import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';

const mapStateToProps = (state: State) => {
  const { auth, remoteConfig } = state;
  return {
    cartCount: auth.user.cartItemsCount,
    gamoogaNotifRestriction: remoteConfig.configs?.gamoogaNotifRestriction || null,
  };
};

export default connect(mapStateToProps)(View);
